import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-51b44ea1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "delete-project-modal__message" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "delete-project-modal__warning" }, " This action cannot be undone. ", -1))

import { ref } from 'vue';
import type { Ref } from 'vue';
import useQuasar from 'quasar/src/composables/use-quasar.js';;

import DSModal from '@/design-system/DSModal.vue';

import { useStore } from '@/store';
import { DELETE_PROJECT } from '@/store/types/actions';
import ProjectInterface from '@/interfaces/Project.interface';


export default /*#__PURE__*/_defineComponent({
  __name: 'DeleteProjectModal',
  setup(__props, { expose: __expose }) {

const store = useStore();
const $q = useQuasar();

const show_modal = ref(false);
const request_pending = ref(false);
const project: Ref<ProjectInterface> = ref({} as ProjectInterface);

const handleDeleteProject = async () => {
  request_pending.value = true;

  try {
    await store.dispatch(DELETE_PROJECT, { id: project.value.id });

    $q.notify({
      progress: true,
      type: 'positive',
      message: 'Project successfully deleted',
      position: 'top-right',
      icon: 'check_circle',
    });

    show_modal.value = false;
  } catch (error) {
    $q.notify({
      progress: true,
      type: 'negative',
      message: 'Error deleting project',
      position: 'top-right',
      icon: 'error',
    });
  } finally {
    request_pending.value = false;
  }
};

const handleCancel = () => {
  show_modal.value = false;
};

const showModal = (delete_project: ProjectInterface) => {
  project.value = delete_project;
  show_modal.value = true;
};

__expose({ showModal });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DSModal, {
    modelValue: show_modal.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((show_modal).value = $event)),
    title: "Delete Project",
    loading: request_pending.value,
    "confirm-label": "Delete",
    variant: "danger",
    onConfirm: handleDeleteProject,
    onCancel: handleCancel
  }, {
    body: _withCtx(() => [
      _createElementVNode("p", _hoisted_1, " Are you sure you want to delete project \"" + _toDisplayString(project.value.name) + "\"? ", 1),
      _hoisted_2
    ]),
    _: 1
  }, 8, ["modelValue", "loading"]))
}
}

})